import React, { PropsWithChildren, useContext } from "react";
import { DefaultNavBarQuery } from "types/graphql-types";

export type MenuContentProviderContextValue = {
  destinations: DefaultNavBarQuery["destinations"]["nodes"] | undefined;
  ships: DefaultNavBarQuery["ships"]["nodes"] | undefined;
  cruisesLaunches: DefaultNavBarQuery["cruisesLaunches"]["nodes"] | undefined;
};

const MenuContentProviderContext =
  React.createContext<MenuContentProviderContextValue>({
    destinations: undefined,
    ships: undefined,
    cruisesLaunches: undefined
  });

type Props = MenuContentProviderContextValue;

export const MenuContentProviderProvider: React.FC<
  PropsWithChildren<Props>
> = ({ children, ...props }) => {
  return (
    <MenuContentProviderContext.Provider value={props}>
      {children}
    </MenuContentProviderContext.Provider>
  );
};

export const useMenuContent = () => {
  return useContext(MenuContentProviderContext);
};
